module.exports = __webpack_public_path__ + "img/icon-reward@3x.6c0bb1d3.png";